import React from 'react';
import { SearchForm } from 'client/components/recruitments/SearchForm/index';
import { RecruitmentList } from 'src/client/components/recruitments/RecruitmentList/index';
import { useRecruitmentListContext } from 'src/client/contexts/recruitments/RecruitmentList';
import { AvailableDates } from 'src/client/components/recruitments/AvailableDates';
import ActionsFooter from 'src/client/components/Footer/ActionsFooter';
import { Calendar } from 'client/components/recruitments/Calendar';
import { SearchModal } from 'src/client/components/recruitments/Modal/index';

type Props = {
  token: string | null;
};

export const RecruitmentsUI = ({ token }: Props) => {
  const {
    ui: { displayMode },
  } = useRecruitmentListContext();
  return (
    <>
      <div className="max-w-5xl mx-auto">
        {displayMode === 'list' && (
          <>
            <div className="sticky top-0 w-full  bg-white border-b border-gray z-10">
              <SearchForm />
              <Calendar />
            </div>
            <div className="available-wrapper">
              <AvailableDates />
              <RecruitmentList />
            </div>
            <ActionsFooter token={token} />
          </>
        )}
        <SearchModal />
      </div>
      <style jsx>{`
        .available-wrapper {
          margin: 20px 20px 0;
        }
        .available-link {
          padding: 11px 20px;
          border: 1px solid #d8d8d8;
          box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
          border-radius: 10px;
          align-items: center;
        }
        .icon-bg {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          justify-content: center;
          align-items: center;
          margin-right: 16px;
        }
      `}</style>
    </>
  );
};
